var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMulticlub = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  x: 1.5,
  y: 4.5,
  fill: "#fff",
  opacity: 0.3,
  rx: 5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M19.5 6h-15A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h15a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 19.5 6m-15-1.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.805 7.922a.214.214 0 0 1 .39 0l1.024 2.222a.21.21 0 0 0 .17.123l2.43.288a.214.214 0 0 1 .12.37l-1.797 1.661a.21.21 0 0 0-.064.2l.477 2.399a.214.214 0 0 1-.315.229l-2.135-1.195a.21.21 0 0 0-.21 0L9.76 15.414a.214.214 0 0 1-.314-.23l.476-2.399a.21.21 0 0 0-.064-.199L8.06 10.925a.214.214 0 0 1 .12-.37l2.43-.288a.21.21 0 0 0 .17-.123z"
})));
export default SvgMulticlub;